export default {
	language: 'English',
	sanqi: {
		zhoushi: "Trend chart",
		biaoti: "Cryptocurrency transactions in highly liquid markets",
		xiangqing: "Years of operation experience has provided users with a rich, flexible, stable, safe and reliable trading environment",
		Global: "Global ecological layout",
		Bank: "Bank level security",
		Focus: "Focus on user experience",
		Convenient: "Facilitate transactions",
		project: "Global project expansion and operation management system, with local service trade centers in many countries",
		level: "With bank level wallet system, real-time financial risk control and multi-dimensional authentication, the financial security team has provided multiple guarantees for capital security in the past decade",
		polish: "Carefully polish the details to make the UI and interaction more comfortable level by level, and the transaction can become a visual enjoyment",
		Android: "Support the operation of Android, IOS and web terminals, and control market information, global markets and transactions in real time anytime, anywhere",
		Download: "Download mobile client and trade freely anytime, anywhere",
		Palm: "Palm Trading",
		Trade: "Trade anytime, anywhere",
		flow: "Mobile experience",
		Smooth: "Smooth operation makes you have a more pleasant experience",
		Real: "Real time quotation",
		time: "Real time update, let you grasp the market trend",
		Rapid: "Fast charging",
		Experience: "Experience quickly and enjoy what you want",
		Join: "Start your contract journey",
		Please: "Please enter your mobile phone / email in the input box below to register Azbit-usa",
		enter: "Please enter your email or mobile number",
		Register: "register",

		regulatory:'regulatory license',
		regulatory_info:"Uncleblock is a legally compliant financial and monetary service company under the supervision of Canada's FINTRAC (Canadian Financial Transaction and Report Analysis Center) and the US SEC (US Securities and Exchange Commission). Uncleblock will comply with all applicable laws and regulations in each jurisdiction in which it operates based on having a financial license. ",
		canada:'Canada (under supervision)',
		certnum:'regulatory certificate number',
		dateissue:'issue date',
		veriurl:'Canadian verification URL',

		white_paper: 'white paper',
	},
	song: {
		low:'Please enter your old password',
	    jgsxf:"Deduction of handling charges for placing orders under express contracts",
	    jgbj:"Deduction of principal under express contract",
	    jgks:"Fast contract order, loss settlement",
	    jgyl:"Quick contract order closing, profit settlement",
	    htcz:"Background recharge",
	    htshcz:"Background audit recharge",
	    bbhr:"Transfer in of currency account",
	    bbhc:"Currency account transfer out",
	    pccl:"Disposal of closed position funds",
	    gmsxf:"Deduction of handling fee for linked sale",
	    ggsxf:"Submit leveraged transactions, net of handling charges",
	    ggbzj:"Submit leveraged transactions, net of margin",
	    gbdj:"Submission of pending purchase freeze",
	    gbkc:"Submit linked purchase deduction",
	    gsdj:"Submit listing freeze",
	    gskc:"Submit linked sales deduction",
	    tbsbjs:"Failed to withdraw currency, locking balance decreased",
	    tbsbch:"Failed to withdraw currency, locked balance withdrawn",
	    tbcg:"Withdrawal succeeded",
	    gyf:"Leveraged trading, charging an overnight fee",
	    gghr:"Transfer in from leveraged account",
	    gghc:"Transfer out of leveraged account",
	    tbdj:"Apply for currency withdrawal and freeze balance",
	    tbkc:"Apply for currency withdrawal deduction balance",
	    mhxh:"Blind box consumption",
	    mhhq:"Blind box acquisition",
	    msxf:"Deduction of handling fee for order placement of second contract",
	    mbj:"Deduct the principal when placing an order",
	    mks:"Second contract order, loss settlement",
	    myl:"Second contract order closing, profit settlement",
	    mhr:"Second contract account transfer in",
	    mhc:"Second contract account transfer out",
	    sfsczj:"Release lock mining to increase available assets",
	    sfsckc:"Release locked warehouse mining deducting frozen assets",
	    sczj:"Locked warehouse mining increases frozen assets",
	    sckc:"Lock mining deducting available assets",
	    scsy:"Lockup mining revenue available assets",
	    ahtcz:"Background recharge remarks",
	    xcbx:"Quick contract order closing settlement, no effective insurance, and the capital remains Azbit-usa hanged",
		bbjx:"Currency currency transaction: the user cancels hanging and unlocking",
		bbth:"Currency currency transaction: the user cancels the linked purchase return",
		wtcd_t:"Commission cancellation, return of handling fee",
		wtcd_b:"Entrusted cancellation and return of deposit",
		bxju_p:"Insurance termination, compensation amount",
		bxju_s:"Termination of insurance, deduction of insured amount",
		bxju_b:"Termination of insurance and deduction of insurance amount",
	},
	iesan: {
		li_a: 'Just focus and leave the rest to us。',
		li_b: 'Automated investment analysis - according to Azbit-usa s position locking and mining, it can customize the trading ideas for investors  main trading currency pairs, and highly autonomous account settings - customize the fund withdrawal comparison column, position comparison column and early warning comparison column according to different customer types. Fully take care of traders with different risk tolerance in the market. Reserve account currency borrowing - the platform provides reserve currency borrowing for warehouse locked mining. You can obtain platform financing currency borrowing by applying only if the digital assets of the account reach 50% of the reservation limit。',
		zuidi: 'Min number',
		b_liord: "Blind box order",
		b_zhomg: "Blind box winning",
		b_xiaohao: "consume",
		b_mangheli: "Blind box gift bag",
		b_qingsong: "Easily discover the super gift bag",
		b_kaiqi: "Open the blind box",
		b_xuyao: "To open the current blind box",
		b_dangqian: "Current balance",
		b_quxiao: "cancel",
		b_ok: "determine",
		b_cuocang: "Lock up and earn money",
		b_dindan: "Blind box order",
		b_genduo: "Load more",
		b_wabao: "Mining treasure",
		b_jiandan: "Mining is easier and easy to receive rewards",
		b_cung: "Lock up and earn money",
		b_shouyi: "Total revenue",
		b_zhiyao: "Pledge quantity",
		b_qianbao: "Wallet balance",
		b_goumai: "purchase",
		b_zhjuanbi: "Lock up and earn money",
		b_num: "Currency deposit quantity",
		b_yuji: "Estimated total revenue",
		b_jin: "near",
		b_rinianhua: "Daily reference annualization",
		b_suochang: "Lock up period",
		b_gtou: "purchase",
		b_jilu: "Lock record",
		b_biaohuao: "Item No",
		b_bizhong: "currency",
		b_shuliang: "Currency deposit quantity",
		b_jixi: "Total interest",
		b_suocang: "Lock time",
		b_shijan: "Expiration time",
		b_zhuangtai: "state",
		b_jinxin: "have in hand",
		b_jieshu: "Has ended",
		b_zhenqui: "Please enter the correct quantity",
		b_tian: "day",
		b_mei: "No more",
		b_maghe: "Blind box",
		b_wakuang: 'Lock mining',
		levermin: "Menge ist geringer als die Mindestzahl"
	},
	chongbi: {
		zaixian:"Online Service",
		fuzhi:"Copy label",
		huazhuan:"Transfer",
		bizhong:"currency",
		keyong:"Available balance",
		cong:"from",
		zhi:"to",
		num:"Transfer quantity",
		shuru:"Please enter transfer quantity",
		whatsapp:"Please enter whatsapp accounts",
		youxiang:"mailbox",
		superior: 'My subordinates',
		tiem: 'time',
		tit: 'My member',
		group: 'Number of teams',
		not: 'No member',
		qukuai: 'Blockchain school',
		fabi: 'Legal currency transaction',
		gonggao: 'Notice',
		xitong: 'System article',
		yonghu: 'User support',
		bangzhu: 'Help center',
		shouyi: 'Revenue rule',
		xinwen: 'News Center',
		xinshou: 'Novice help',
		jiaoyi: 'Transaction rules',
		kuaixun: 'news flash',
	},
	// 导航
	header: {
		wakuang: 'Lock mining',
		miaohy: 'Speed contract',
		home: 'home',
		markets: 'Markets',
		fiat: 'Fiat',
		c2c: 'C2C',
		exchange: 'exchange',
		lever: 'Lever',
		myshop: "Shops",
		assets: 'Assets',
		help: 'Help',
		login: "Login",
		sign: 'Sign Up',
		accountSet: 'Account',
		tradeLog: 'Transaction log',
		receiveSet: 'Collection ',
		identify: 'Authentication',
		jchange: 'Azbit-usa',
		logout: 'Logout',
		themedark: 'Night mode',
		themeday: 'Day Mode',
	},
	// 登录注册
	lg: {
		login: 'Login',
		register: 'Sign Up',
	},
	// 首页
	home: {
		vol: '24H Vol',
		c01: "The world's leading digital asset trading platform",
		c02: 'Deliver secure, trusted digital asset trading and asset management services to millions of users in more than 130 countries worldwide',
		c03: 'Safe and trustworthy',
		c04: '5 years experience in digital asset financial services',
		c05: 'Professional distributed architecture and anti-DDOS attack system',
		c06: 'Global ecological layout',
		c07: 'A number of countries set up localized transaction service centers ',
		c08: 'to create a blockchain ecosystem with multiple business forms',
		c09: 'Customer first',
		c10: 'Establish a preemptive payment mechanism',
		c11: 'Set up an investor protection fund',
		c12: 'Multi-platform terminal trading anytime, anywhere',
		c13: 'Covers multiple platforms of iOS, Android, Windows,and supports full business fAzbit-usations',
		sweep: 'Scan code download',
		android: 'Android',
		pinput: 'Please enter your email or mobile number',
		atrade: 'Register a Azbit-usa Global Station Account and Start the Trading Journey'
	},
	// 底部
	foo: {
		about: 'About us',
		support: 'User support',
		contact: 'Contact us',
		qq: 'QQ',
		email: 'Email',
	},
	// 行情
	market: {
		exchange: 'Azbit-usa',
		selfmarket: 'Favorites',
		allmarket: 'All',
		symbol: 'Pair',
		newprice: 'Last Price',
		change: 'Change',
		highprice: 'High',
		lowprice: 'Low',
		vol: '24H Vol',
	},
	// 公共交易
	td: {
		purchase: "Purchase price",
		transaction: "Transaction price",
		service: "Service charge",
		profit: "Profit and loss",
		buy: 'buy',
		sell: 'sell',
		currency: 'currency',
		num: 'number',
		time: 'time',
		limit: 'limit',
		price: 'Unit Price',
		method: 'pay way',
		total: 'Total',
		inwant: 'Please input',
		do: 'operation',
		more: 'Load more',
		nomore: 'No more',
		nodata: 'No data',
		trade: 'trade',
		buynum: 'Purchase quantity',
		sellout: 'Sell ',
		buyin: 'Buy ',
		all: 'all',
		allbuy: 'Buy all',
		allsell: 'Sell all',
		buytotal: 'Please enter the total amount you want to purchase.',
		selltotal: 'Please enter the total amount you want to sell.',
		buyallnum: 'Please enter the quantity you want to buy.',
		sellallnum: 'Please enter the quantity you want to sell.',
		tradeTotal: 'Total transaction volume',
		doceil: 'Automatically cancel in seconds',
		place: 'Place an order',
		waitpay: 'Pending payment',
		paycode: 'Payment code',
		finished: 'Completed',
		ceiled: 'Cancelled',
		payed: 'Paid',
		nofinish: 'incomplete',
		buyer: 'Buyer',
		seller: 'seller',
		callWay: 'contact way',
		placeTime: 'Order time',
		renum: 'Reference number',
		canceil: 'cancel',
		confirm: 'confirm',
		pwd: 'Please enter the transaction password.',
		coincode: 'Monetary unit',
		pcoin: 'Please choose monetary unit.'
	},
	// 法币交易
	fat: {
		// LegalPayDetail
		orderLog: 'Order record',
		fatdLog: 'legal trade record',
		shoper: 'business',
		faLog: 'legal trade record',
		tdType: 'Transaction type',
		odStatus: 'Order status',
		pwaitPay: 'Please wait for the buyer to pay',
		odFinish: 'The order has been completed',
		odCeil: 'The order has been cancelled',
		odPay: 'Payment has been made. Please check the payment information carefully.',
		tdCeil: 'Cancel transaction',
		pCeil: 'If you have paid , do not cancel it',
		paySure: 'Payment confirm',
		pdopay: 'Please confirm that you have paid',
		badClick: 'Malicious clicks will freeze accounts directly',
		receivePay: 'Receipt confirmation',
		payReceive: 'Please confirm that the buyer has paid you.',
		receivePays: 'Confirmation of receivables',
		// LegalPay
		payPlease: 'Please pay',
		tdPrice: 'Unit price',
		tdNum: 'Transaction volume',
		payinfo: 'Payment information',
		banknum: 'Bank account',
		realName: 'Real name',
		shoperZname: 'Merchant sub branch',
		shoperNum: 'Merchant account',
		odCeil: 'Cancel order',
		imPay: 'have paid, Confirm',
		// LegalSeller
		register_time: 'Register time',
		odtotal: 'Assembly sheet',
		odmonth: '30 days sheet',
		odfinish: 'Completion sheet',
		odrate: 'Completion rate',
		submit: 'publish',
		phone: 'phone',
		mysell: 'My sale',
		mybuy: 'My purchase',
		realAuth: 'Real name authentication',
		advAuth: 'Advanced authentication',
		linebuy: 'Online purchase',
		linesell: 'Sell online',
		tipPay: 'Please contact the merchant for payment within 24 hours. If the payment exceeds 24 hours, it will be cancelled automatically.',
		notlow: 'No less than the minimum limit',
		nothigh: 'Do not exceed the maximum limit',
		notnum: 'Do not exceed the maximum quantity',
		// LegalShopDetail
		type: 'type',
		status: 'status',
		seeOrder: 'View order',
		withdraw: 'withdraw',
		abnormal: 'abnormal',
		lowershelf: 'Lower shelf',
		protection: 'Rights protection',
		apply: 'Apply rights protection',
		psType: 'Please select the type',
		pselect: 'Please choose',
		alipay: 'Alipay',
		wechat: 'WeChat',
		bank: 'Bank card',
		minNum: 'Minimum trading volume',
		maxNum: 'Maximum trading volume',
		wantBuy: 'want to buy',
		pnums: 'Please enter quantity',
		pmin: 'Please enter the minimum transaction volume',
		pmax: 'Please enter the maximum trading volume',
		pnot: 'Maximum trading volume should not be less than minimum trading volume',
		// MyLegalShops
		myshops: 'personal stores',
		name: 'Name',
		fiatSub: 'Legal tender',
		shoper_balance: 'Merchant balance',
		enterShop: 'Enter shop',
		// shop_legal_pay_detail
		payedWait: 'Payment made awaiting verification',
		yes: 'YES',
		no: 'NO',
		sd: 'Lock in balance',
		journal: 'Balance log',
		business: 'business',
		user: 'user',
		backdone: 'Withdrawn',
		busbalance: 'Merchant balance',
		userbalance: 'User balance',
	},
	ctc: {
		ctc: 'C2C',
		myRelease: 'My release of C2C',
		myTrade: 'C2C I traded',
		and: 'yes',
		balance: 'balance',
		buynum: 'Buying vol',
		sellnum: 'Selling vol',
		bankTransfer: 'Bank transfer',
		payim: 'Must pay by oneself',
		pbuyNum: 'enter the purchase quantity',
		pprice: 'Please enter unit price',
		payway: 'Please choose the mode of payment.',
		psellNum: 'Please enter the quantity sold.',
		suerePlace: 'Do you confirm the order?',
		detail: 'details',
		payinfo: 'Payment information',
		Payee: 'Payee',
		total: 'Total',
		name: 'name',
		cardnum: 'Card number',
		receivePay: 'Confirmation of receivables',
		ceilConfirm: 'Confirm cancel the transaction?',
		paySeller: 'Please confirm that you have paid the seller, malicious clicks will freeze the account.',
		payBuyer: 'Please confirm that you have received payment information from the buyer.',
		account: 'Account number',
		sellerPay: 'Please confirm that the buyer has paid you?',
		payattion: 'Please pay to the seller as soon as possible after payment confirmation, malicious clicks will directly freeze the account.',
		log: 'c2c已完成订单'
	},
	// 合约
	lever: {
		purchase: "Purchase price",
		Expected: "Estimated profit and loss",
		countdown: "countdown",
		second: "second",
		jiaoyinum: "number",
		houmaicg: "Successful purchase",
		nowentrust: 'Open orders',
		hisentrust: 'Order history',
		lvchi: 'Leverage position',
		all: 'all',
		or: 'or',
		gotrade: 'Start trading',
		tdrecord: 'Transaction record',
		dealed: 'Completed',
		notdeal: 'No deal',
		loading: 'Loading',
		entotal: 'Total entrusted amount',
		canuse: 'available ',
		std: 'Market',
		xtd: 'Limit',
		pprice: 'Please enter the price',
		phand: 'Please enter the number of purchases',
		phandsell: 'Please enter the quantity for sale',
		pwd: 'password',
		ppwd: 'Please enter the transaction password',
		psw: 'transaction password',
		equal: 'equal to',
		times: 'time',
		timed: 'multiple',
		hand: 'hand',
		miao: 's',
		miaos: 'Seconds',
		hands: 'hands',
		ptimes: 'Please select multiples',
		phands: 'Please select the number of hands',
		contractVal: 'contract market value',
		bail: 'Margin',
		canBail: 'Available margin',
		charge: 'transaction service fee',
		domore: 'Buy (long)',
		doshort: 'sell (short)',
		dmore: 'Long',
		dshort: 'Short',
		sureOd: 'confirm order',
		noless: 'The number of hands cannot be lower than',
		nomore: 'The number of hands cannot be higher than',
		tdnum: 'Total',
		risk: 'risk rate',
		allloss: 'total position profit and loss',
		onehouse: 'One button closes',
		type: 'type',
		entrustPrice: 'commission price',
		openPrice: 'opening price',
		nowPrice: 'current price',
		styPrice: 'Take profit price',
		stsPrice: 'Stop Loss Price',
		openTime: 'open time',
		closeTime: 'closing time',
		rate: 'handling fee',
		nightFee: 'overnight fee',
		loss: 'profit and loss',
		setloss: 'Set stop loss stop loss',
		expectProfit: 'expected profit',
		expectLoss: 'expected loss',
		allClose: 'All closing',
		moreClose: 'Only flat more than one',
		nullClose: 'Only empty single',
		sureClose: 'Confirm the position? ',
		thanZearo: 'The value set must be greater than 0',
		listin: 'Pending order',
		tdin: 'in the transaction',
		closein: 'Close the position',
		closed: 'Closed',
		revoked: 'revoked',
		revokeOrder: 'Are you sure to cancel the order? ',
		ping: 'Close the position',
		revoke: 'Cancel',
		sureping: 'Determine the closure?？',
		thanzone: 'The value set must be greater than 0',

		profitability: 'Profitability',
		profit_: 'Profit',
	},
	// 币币
	cuy: {
		direction: 'direction',
		total: 'total',
		price: 'price',
		sell: 'sell',
		buy: 'buy',
		allStation: 'Market trades',
		buyPrice: 'Price',
		buynum: 'Amount',
		sellPrice: 'Price',
		sellnum: 'Amount',
		tdPrice: 'Total',
		or: 'or',
		tdStart: 'Start trading',
		pbPrice: 'Please enter the bid price',
		pbNum: 'Please enter the purchase amount',
		psPrice: 'Please enter the selling price',
		psNum: 'Please enter the sales amount',
		fixPrice: 'Limit',
		Mtrans: 'Market',
		available: 'available',
		revoke: 'Undo',
		loading: 'Loading',
		confirmCancel: 'Are you sure you want to cancel? ',
		confirm: 'OK',
		cancel: 'Cancel',
		nomore: 'No more data',
		evelPrice: 'Average Price'
	},
	// 资产
	asset: {
		text1:'Charging address',
		text2:'Please enter the charging address',
		text3:'Charging quantity',
		text4:'Please enter the charging quantity',
		text5:'Submit',
		miao_account: 'Speed contract account',
		assets: 'assets',
		currency_account: 'coin account',
		lever_account: 'leverage account',
		fince_account: 'French account',
		change_account: 'Transaction account',
		assets_hua: 'Fund transfer',
		all_assets: 'total assets',
		currency: 'currency',
		canuse: 'available',
		frezz: 'freeze',
		conversion: 'Folding',
		charging: 'filling coins',
		withdraw: 'Ticks',
		address_bind: 'bind withdraw address',
		address_withdraw: 'Trading address management',
		record: 'record',
		address_charge: 'Charge address',
		address_width: 'Ticket Address',
		copy: 'copy',
		ercode: 'QR code',
		reminder: 'Warm tips',
		notcharge: 'Do not recharge any non-USDT assets to the above address, otherwise the assets will not be retrieved',
		support: 'The coin only supports the simple send method. The use of other methods (send all) is temporarily unable to be credited. Please understand. ',
		minnum: 'the minimum number of coins',
		ratenum: 'fee fee',
		havenum: 'number of arrivals',
		from: 'From',
		to: 'to',
		transfer: 'swiping',
		tfnum: 'the number of transfers',
		ptfnum: 'Please enter the lowest',
		dtfnum: 'the number of strokes',
		canbalance: 'available balance',
		sureConfirm: 'confirm transfer',
		moneyRecord: 'financial record',
		pNum: 'Please enter the number of transfers',
		leverUse: 'Leverage account available',
		legalUse: 'French account available',
		changeUse: 'Transaction account available',
		look: 'View',
		chargeRecord: 'charged currency record',
		status: 'Tracking status',
		noopen: 'This feature is not open yet',
		enterAdderses: 'Please enter the coin address',
		enterNum: 'Please enter the number of coins',
		lessMin: 'The number of coins entered is less than the minimum',
		tips01: 'Do not recharge any other assets to the above address, otherwise the assets will not be recovered. ',
		tips02: 'Currency only supports the simple send method, the use of other methods (send all) for the currency can not be accounted for temporarily, please understand. ',
		beizhu: 'Remarks',
		pbeizhu: 'Please enter a note',
		add: 'add',
		addressList: 'address list',
		delete: 'delete',
		norec: 'no record',
		selectCurrency: 'Please select currency',
		chainType: "Chain type"
	},
	// 账户设置
	set: {
		mycode2: 'My authorization code',
		copycode2: 'Copy authorization code',
		uaccont: 'Your account security level:',
		strong: 'strong',
		middle: '中中',
		weak: 'weak',
		min: 'low',
		heigh: 'high',
		complete: 'Complete more information to ensure account security',
		mycode: 'my invitation code',
		copycode: 'Copy invitation code',
		bindphone: 'Bind the phone',
		bindemail: 'Binding Mailbox',
		loginpwd: 'login password',
		noBind: 'unbound',
		binds: 'binding',
		bind: 'de bind',
		binded: 'bind',
		net: 'The Internet account is at risk of being stolen. It is recommended that you change your password periodically to protect your account. ',
		reset: 'Modify',
		setPsw: 'Set the transaction password to ensure transaction security. ',
		goSet: 'Go to set',
		bindAccount: 'Bind redemption account',
		duihuan: 'Bind the account to redeem points',
		copysuccess: 'Copy success',
		copyfail: 'copy failed',
		recopy: 'Please copy again',
		account: 'account',
		detail: 'details',
		val: 'amount',
		forgetPsw: 'Forgot password',
		code: 'verification code',
		getCode: 'Get code',
		setPsw: 'set password',
		enterPsw: 'Please enter a password',
		pswFalse: 'The passwords entered twice are inconsistent',
		enterPswagain: 'Please enter your password again',
		jsetPsw: 'Set up the transaction password',
		jenterPsw: 'Please enter the transaction password',
		jenterPswagain: 'Please enter the transaction password again',
		enterAccount: 'Please enter an account',
		enterCode: 'Please enter the verification code',
		accountFalse: 'The phone or email account you entered does not meet the rules!',
		second: 'second',
		sendCode: 'send',
		sendsucc: 'send success',
		enterPswTwo: 'Please enter the password twice',
		rest: 'remaining',
		yes: 'yes',
		no: 'no',
		yorn: 'Whether to Set Transaction Password',
	},
	// 身份认证
	auth: {
		identity: 'Authentication',
		name: 'name',
		idcard: 'identity document',
		upimg: 'Please upload a photo of the identity document, the first one is the front, the second one is the reverse side, and the third one is the front photo of the hand-held identity document. ',
		submit: 'submit',
		auditing: 'Audit...',
		certified: 'Certified!',
		pname: 'Please enter a name',
		pidcard: 'Please enter the ID number',
		pimg: 'Please upload a certificate picture!',
	},
	// 收款方式
	seting: {
		pmethod: 'payment method',
		truename: 'real name',
		opening: 'Bank name',
		bank: 'bank card number',
		alipay: 'Alipay account',
		wename: 'WeChat nickname',
		wechat: 'WeChat account',
		pname: 'Please enter your real name',
		popen: 'Please enter the name of the bank name',
		pcard: 'Please enter the bank card number',
		palipay: 'Please enter Alipay account',
		Pwname: 'Please enter the WeChat nickname',
		pwaccount: 'Please enter WeChat account',
		pimg1: 'Wechat collection code',
		pimg2: 'Alipay payment code'
	},
	// 帮助中心
	news: {
		seeall: 'View all',
		helpcenter: 'Help Center',
		back: 'Return',
		gonggao: 'Notice'
	},
	//登录
	login: {
		welcome: 'Welcome to login',
		phoneLogin: 'Mobile',
		emailLogin: 'Mailbox',
		account: 'account',
		psw: 'password',
		login: 'login',
		nouser: 'Not a user of Azbit-usa? ',
		goRegister: "Register now and start trading on the world's leading digital asset trading platform",
		registerFree: 'free registration',
		psw6: "Password can't be less than six"
	},
	register: {
		register: 'Register',
		phoneRegister: 'Mobile',
		emailRegister: 'mailbox',
		country: 'nationality',
		enterPhone: 'Please enter the phone number',
		enterEmail: 'Please enter the mailbox',
		psw16: 'The password is between 6-16',
		inviteCode: 'Invitation Code',
		sel: 'Must fill',
		sel2: 'not required',
		read: 'I have read and agree',
		xieyi: 'User Agreement',
		tips01: 'Do not modify the nationality information after registration, please be sure to choose it. ',
		tips02: 'Verification emails may be misidentified as spam, please check. ',
		tips03: 'Please save your Azbit-usa account and login password. ',
		tips04: 'Do not use the same login password as other websites. ',
		emailFalse: 'The mailbox you entered does not match the rule'
	},
	// 积分兑换
	jc: {
		title: 'JC Convertible Digital Assets BEAU Platform',
		balance: 'balance',
		cannum: 'Available JC Quantity',
		new: 'Latest Price',
		exnum: 'Azbit-usa Quantity',
		pnum: 'Please enter JC number',
		canex: 'Convertible BEAU Quantity',
		exnow: 'E xchange',
		record: 'Azbit-usa Record',
		exprice: 'Azbit-usa price',
		extime: 'Azbit-usa time',
		not: 'The number of available integrals is insufficient',
		usenum: 'Use JC Quantity',
		out: 'Exit',
		gotd: 'To trade'
	}
}



// WEBPACK FOOTER //
// ./src/lang/en.js